export const testimonialConstants = [
  {
    comment:
      'Lorem ipsum dolor sit amet consectetur elit ut aliquam purus sit amet',
    pics: '/assets/icons/testimonialPics.png',
    title: 'VC, FUT Minna',
    id: 1,
  },
  {
    comment:
      'Lorem ipsum dolor sit amet consectetur elit ut aliquam purus sit amet',
    pics: '/assets/icons/testimonialPics.png',
    title: 'VC, FUT Bida',
    id: 2,
  },
  {
    comment:
      'Lorem ipsum dolor sit amet consectetur elit ut aliquam purus sit amet',
    pics: '/assets/icons/testimonialPics.png',
    title: 'VC, FUT Ilorin',
    id: 3,
  },
  {
    comment:
      'Lorem ipsum dolor sit amet consectetur elit ut aliquam purus sit amet',
    pics: '/assets/icons/testimonialPics.png',
    title: 'VC, FUT Kwara',
    id: 4,
  },
  {
    comment:
      'Lorem ipsum dolor sit amet consectetur elit ut aliquam purus sit amet',
    pics: '/assets/icons/testimonialPics.png',
    title: 'VC, FUT FCT',
    id: 5,
  },
]
